import { render, staticRenderFns } from "./ShipmentWorldMap.vue?vue&type=template&id=1c0bdd88&scoped=true"
import script from "./ShipmentWorldMap.vue?vue&type=script&lang=js"
export * from "./ShipmentWorldMap.vue?vue&type=script&lang=js"
import style0 from "./ShipmentWorldMap.vue?vue&type=style&index=0&id=1c0bdd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bdd88",
  null
  
)

export default component.exports